import type { EventProps } from 'react-big-calendar';
import { useMemo } from 'react';
import { Box, Paragraph } from '@zillow/constellation-10';

import { getTourEventTimeRange } from '../../../../utils/formatTime';
import { type ZCalendarEvent } from '../../../../constants/TourCalendar';

type CalendarEventWrapperParams = {
  selectedEvent?: ZCalendarEvent;
};
type CalendarEventProps = CalendarEventWrapperParams & EventProps<ZCalendarEvent>;

const CalendarEvent = (props: CalendarEventProps) => {
  const { event, title } = props;
  const timeRange = useMemo(() => getTourEventTimeRange(event), [event]);

  return (
    <Box css={{ height: '100%' }} title={`${title} ${timeRange}`}>
      <Paragraph css={{ whiteSpace: 'nowrap' }} className="calendar-event-text" textStyle="body-sm-bold">
        {title}
      </Paragraph>
      <Paragraph css={{ whiteSpace: 'nowrap' }} className="calendar-event-text" textStyle="body-xs">
        {timeRange}
      </Paragraph>
    </Box>
  );
};

const CalendarEventWrapper = (params: CalendarEventWrapperParams) => (props: EventProps<ZCalendarEvent>) => {
  return <CalendarEvent {...params} {...props} />;
};

export default CalendarEventWrapper;
